import { ActionTree } from 'vuex';
import { ConfigurationState } from './types';
import { RootState } from '@/vuex/types';
import { state } from '@/modules/configuration/store';
import EventBus from '@/communication/EventBus';

export const actions: ActionTree<ConfigurationState, RootState> = {
    changeTheme({ commit }, themeName: string) {
        commit('setTheme', state.appThemes[themeName]);
        EventBus.$emit('themeChanged');
    },
    changeEnvironment({ commit }, environmentName) {
        commit('setEnvironment', state.environments[environmentName]);
        EventBus.$emit('environmentChanged');
    },
    changeAppWindowMode({ commit }, appWindowMode) {
        commit('setAppWindowMode', appWindowMode);
        EventBus.$emit('appWindowModeChanged');
    },
};
